<template>
  <svg
    id="filters"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="29.965"
    height="21.336"
    viewBox="0 0 29.965 21.336">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_541"
          data-name="Rectangle 541"
          width="29.965"
          height="21.336"
          fill="currentColor" />
      </clipPath>
    </defs>
    <g id="Group_379" data-name="Group 379" clip-path="url(#clip-path)">
      <path
        id="Path_453"
        data-name="Path 453"
        d="M17.9,4.136H1.308A1.077,1.077,0,0,1,.125,3.348,1.02,1.02,0,0,1,1.02,2.076c.128-.01.258-.006.387-.006H17.9c0-.35,0-.668,0-.987A1.014,1.014,0,0,1,18.925,0,1.026,1.026,0,0,1,19.96,1.084q.011,2.065,0,4.13a1.033,1.033,0,1,1-2.062,0c0-.343,0-.685,0-1.079"
        transform="translate(-0.083)"
        fill="currentColor" />
      <path
        id="Path_454"
        data-name="Path 454"
        d="M20.446,176.425c0-.37-.005-.691,0-1.011a1.028,1.028,0,1,1,2.056-.044q.028,2.146,0,4.292a1,1,0,0,1-1.054.993,1.013,1.013,0,0,1-1-1.046c-.008-.353,0-.707,0-1.1-.158-.008-.292-.021-.426-.021q-6.373,0-12.746,0a2.848,2.848,0,0,1-.545-.038,1.024,1.024,0,0,1,.115-2.018c.128-.012.258-.009.387-.009H20.446Z"
        transform="translate(-5.416 -159.319)"
        fill="currentColor" />
      <path
        id="Path_455"
        data-name="Path 455"
        d="M165.885,105.009q-3.4,0-6.805,0a1.026,1.026,0,0,1-1.037-1.388.96.96,0,0,1,.718-.632,2.258,2.258,0,0,1,.48-.043q6.66,0,13.32,0c.086,0,.172,0,.258.005a1.028,1.028,0,0,1,.986,1.066,1,1,0,0,1-1.05.993c-2.29.006-4.58,0-6.87,0"
        transform="translate(-144.348 -94.066)"
        fill="currentColor" />
      <path
        id="Path_456"
        data-name="Path 456"
        d="M9.555,81.046c0-.379-.005-.7,0-1.023a1.029,1.029,0,0,1,2.058-.032q.021,2.146,0,4.293a1.017,1.017,0,0,1-1.044,1.009,1.029,1.029,0,0,1-1.014-1.037c-.007-.365,0-.73,0-1.144H9.16q-4.018,0-8.036,0a1.042,1.042,0,0,1-.99-.542.962.962,0,0,1,.037-1.041,1.078,1.078,0,0,1,.994-.487q1.484,0,2.969,0h5.42Z"
        transform="translate(0 -72.169)"
        fill="currentColor" />
      <path
        id="Path_457"
        data-name="Path 457"
        d="M227.135,198.338c1.431,0,2.861-.007,4.292,0a1.021,1.021,0,0,1,.954,1.5,1.083,1.083,0,0,1-1.048.562c-1.355,0-2.71.014-4.066.02-1.517.007-3.033.019-4.55.018a1.014,1.014,0,0,1-1.025-.77.981.981,0,0,1,.474-1.13,1.559,1.559,0,0,1,.678-.156c1.43-.014,2.861-.007,4.291-.007Z"
        transform="translate(-202.542 -181.232)"
        fill="currentColor" />
      <path
        id="Path_458"
        data-name="Path 458"
        d="M257.049,26.123h-2.614a1.067,1.067,0,0,1-1.09-.647,1.024,1.024,0,0,1,.972-1.414c.957-.026,1.915-.027,2.872-.036.861-.008,1.721-.015,2.582-.016a1.017,1.017,0,0,1,1.111,1,1.028,1.028,0,0,1-1.09,1.063c-.914.011-1.829,0-2.743,0v.048"
        transform="translate(-231.426 -21.94)"
        fill="currentColor" />
    </g>
  </svg>
</template>
